import React, {useState} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useWebsite } from '../../Data/Website';
import { PageLoading } from '../../Components/Loading';
import Toggle from '../../Components/Button/Toggle';
import { useShortenUrls } from '../../Data/ShortLinks';
import CopyableValue from '../../Components/Formatting/CopyableValue';

const Links = () => {
    const {website} = useWebsite(true);

    return <>
        <TopBar left="/more" title="Website links" />
        <Page>
            {!website && <PageLoading />}
            {website && website.type ==='getsoapy' && <GetSoapy {...{website}} />}
            {website && website.type ==='thirdparty' && <ThirdParty {...{website}} />}
            {website && website.type ==='none' && <None {...{website}} />}
        </Page>
    </>
}

const GetSoapy = ({website}) => {
    const longUrls = {
        home: `https://${website.soapySubdomain}.getsoapy.com/`,
        quote: `https://${website.soapySubdomain}.getsoapy.com/#quote`,
        pay: `https://${website.soapySubdomain}.getsoapy.com/#pay`,
        portal: `https://${website.soapySubdomain}.getsoapy.com/portal`,
    };

    return <TheLinks
        blurb="You can use the following links to send people directly to different parts of your getSoapy website."
        longUrls={longUrls}
    />
}

const ThirdParty = ({website}) => {
    const longUrls = {
        home: `https://${website.domain}/`,
        quote: website.useHostedQuotePage ?
            `https://getsoapy.com/hosted/quote/${website.businessId}` :
            `https://${website.domain}${website.quotesPage ?? ''}`,
        pay: website.useHostedPaymentsPage ?
            `https://getsoapy.com/hosted/pay/${website.businessId}` :
            `https://${website.domain}${website.paymentsPage ?? ''}`,
        portal: website.useHostedPortalPage ?
            `https://getsoapy.com/hosted/portal/${website.businessId}` :
            `https://${website.domain}${website.portalPage ?? ''}`,
    };

    return <TheLinks
        blurb={<>
            You can use the following links to send people directly to different pages on your website.<br />
            If these are incorrect, you can change them in the settings.
        </>}
        longUrls={longUrls}
    />
}

const None = ({website}) => {
    const longUrls = {
        home: false,
        quote: `https://getsoapy.com/hosted/quote/${website.businessId}`,
        pay: `https://getsoapy.com/hosted/pay/${website.businessId}`,
        portal: `https://getsoapy.com/hosted/portal/${website.businessId}`,
    };

    return <TheLinks
        blurb={<>
            You've chosen to have no website, but your customers can still use the getSoapy widgets at the links below.<br />
            If you'd like to have a free website you can change this in the settings.
        </>}
        longUrls={longUrls}
    />
}

const TheLinks = ({blurb, longUrls}) => {
    const [shortenUrls, setShortenUrls] = useState(false);
    const {shortUrls} = useShortenUrls(longUrls)

    return <div>
        <div className="prose prose-sm">
            {blurb}
        </div>

        <Toggle enabled={shortenUrls}
            onChange={setShortenUrls}
            className="mt-4"
            label="Show short links"
            hideFocusRing
            ring
        />

        <div className="flex flex-col space-y-4 mt-4">
            {longUrls.home && <CopyableValue title="Home page"
                value={shortenUrls ? (shortUrls?.home ?? 'Shortening...') : longUrls.home}
            />}
            <CopyableValue title="Quote widget"
                value={shortenUrls ? (shortUrls?.quote ?? 'Shortening...') : longUrls.quote}
            />
            <CopyableValue title="Pay widget"
                value={shortenUrls ? (shortUrls?.pay ?? 'Shortening...') : longUrls.pay}
            />
            <CopyableValue title="Customer portal"
                value={shortenUrls ? (shortUrls?.portal ?? 'Shortening...') : longUrls.portal}
            />
        </div>
    </div>
}


export default Links;
